export const GLOBAL_FOOTER_HEIGHT = 30;
